import PropTypes from 'prop-types';
import { Navigate, useSearchParams } from 'react-router-dom';
import { PATH_DASHBOARD } from '@/routes/paths';

/**
 * Relatórios e Cupons mudaram de lugar duas vezes, e cada endereço antigo segue
 * em favoritos, no histórico e em artigos de ajuda. Com `replace`, o voltar do
 * navegador não cai de novo no endereço que redireciona.
 *
 * As rotas avulsas de cada relatório (`reports/abandoned-sales` etc.) ficam
 * onde estão: só `reports` e `coupons` eram as páginas que mudaram de lugar.
 */
export const mySalesLegacyRoutes = [
  { path: 'reports', element: <Navigate to={PATH_DASHBOARD.general.mySalesReports} replace /> },
  { path: 'coupons', element: <Navigate to={PATH_DASHBOARD.general.mySalesCoupons} replace /> },
];

// Abas de Minhas Vendas que viraram tela própria. `?tab=reports` e `?tab=coupons`
// só existiram entre a CKTPL-1533 e a CKTPL-1534; sem o redirecionamento, a página
// trocaria a aba desconhecida por Aprovadas, sem aviso. `?tab=refund_requested` é
// de antes do submenu de Reembolso, e abriria a lista sem a cara de tela própria.
// Map, e não objeto: a chave vem da URL, e `?tab=constructor` acharia o protótipo.
const MY_SALES_MOVED_TABS = new Map([
  ['reports', PATH_DASHBOARD.general.mySalesReports],
  ['coupons', PATH_DASHBOARD.general.mySalesCoupons],
  ['refund_requested', PATH_DASHBOARD.general.mySalesRefundRequests],
]);

// Fica na rota, por fora do OrdersProvider: dentro da página, a aba desconhecida
// cairia em Aprovadas e pediria /orders/ antes de o redirecionamento acontecer.
export function MySalesMovedTabRedirect({ children }) {
  const [searchParams] = useSearchParams();
  const movedTo = MY_SALES_MOVED_TABS.get(searchParams.get('tab'));

  if (movedTo) {
    return <Navigate to={movedTo} replace />;
  }

  return children;
}

MySalesMovedTabRedirect.propTypes = {
  children: PropTypes.node.isRequired,
};
